import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const Skeleton = ({ className }: { className?: string }) => {
  return (
    <Container className={className}>
      <Thumbnail />
      <Text width='60%' />
      <Text width='80%' />
      <Text width='60%' />
    </Container>
  );
};

export const Placeholder = () => {
  return (
    <Wrapper>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
        <SkeletonContainer key={index}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </SkeletonContainer>
      ))}
    </Wrapper>
  );
};

const Container = styled.div`
  width: calc((100% - 2px) / 2);
  flex-basis: calc((100% - 2px) / 2);
  margin-bottom: 24px;
  :nth-of-type(2n) {
    margin-left: 2px;
  }

  @media screen and (min-width: 450px) {
    width: calc((100% - 18px) / 3);
    flex-basis: calc((100% - 18px) / 3);
    margin-left: 9px;
    &:nth-of-type(3n + 1) {
      margin-left: 0;
    }
  }
`;

const Thumbnail = styled.div`
  width: 100%;
  padding-top: 119%;
  background-color: ${vars.v3Color.gray150};
  margin-bottom: 12px;
`;

const Text = styled.div<{ width: string }>`
  width: ${({ width }) => `${width}`};
  height: 14px;
  border-radius: 2px;
  background-color: ${vars.v3Color.gray150};

  &:not(:last-of-type) {
    margin-bottom: 6px;
  }
  &:last-of-type {
    margin-bottom: 40px;
  }
`;

const Wrapper = styled.div`
  padding: 0 16px;
`;

const SkeletonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div:last-of-type {
    margin-left: 2px;
  }
`;
